import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Cookies() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <section className="pt-32 pb-20 px-4">
        <div className="max-w-3xl mx-auto prose prose-slate">
          <h1 className="font-heading font-bold text-3xl text-municipal mb-2">Política de Cookies</h1>
          <p className="text-sm text-gray-400 mb-8">Última actualización: 27 de julio de 2026</p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">¿Qué es una cookie?</h2>
          <p className="text-gray-600 leading-relaxed">
            Una cookie es un pequeño fichero de texto que un sitio web almacena en tu navegador. Este portal utiliza cookies técnicas
            imprescindibles para su funcionamiento (por ejemplo, para mantener tu sesión de administrador iniciada) y no utiliza
            cookies de publicidad ni de seguimiento comercial.
          </p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Cookies utilizadas en este portal</h2>
          <div className="not-prose overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Nombre</TableHead>
                  <TableHead>Tipo</TableHead>
                  <TableHead>Duración</TableHead>
                  <TableHead>Finalidad</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell>sfh_admin_token</TableCell>
                  <TableCell>Técnica (localStorage)</TableCell>
                  <TableCell>Sesión / 24h</TableCell>
                  <TableCell>Mantener la sesión iniciada del panel de administración</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>sfh_admin_session</TableCell>
                  <TableCell>Técnica (localStorage)</TableCell>
                  <TableCell>Sesión / 24h</TableCell>
                  <TableCell>Recordar los datos del administrador conectado</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Cómo desactivar las cookies</h2>
          <p className="text-gray-600 leading-relaxed">
            Puedes eliminar o bloquear estas cookies desde la configuración de tu navegador. Ten en cuenta que, al ser cookies técnicas
            necesarias para el acceso al panel de administración, su bloqueo impedirá el uso de dicha función, sin afectar al wizard
            público de solicitud de recogida.
          </p>

          <h2 className="font-heading font-semibold text-xl text-municipal mt-8 mb-3">Más información</h2>
          <p className="text-gray-600 leading-relaxed">
            Para más información sobre el tratamiento de tus datos personales, consulta nuestra{" "}
            <a href="/privacidad" className="text-municipal underline">Política de Privacidad</a>.
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
